import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../utils/massActions'
import { isSubArchive } from '../../utils/route'

import {
  FLAT_ACTION_ARCHIVE_ITEM,
  FLAT_ACTION_ARCHIVE_MASS,
  FLAT_ACTION_EMAIL_ITEM,
  FLAT_ACTION_MASS_EMAIL_ALL_USERS,
  FLAT_ACTION_MASS_EMAIL_LANDLORDS,
  FLAT_ACTION_MASS_EMAIL_TENANTS,
  FLAT_ACTION_RESTORE_ITEM,
  FLAT_ACTION_RESTORE_MASS,
} from './Flat.constants'

export function getFlatTableNotificationTitle({
  action,
  count,
  t,
  totalCount,
}) {
  const types = {
    [FLAT_ACTION_ARCHIVE_ITEM]: t('Notification.CommonTitleArchivedKey'),
    [FLAT_ACTION_ARCHIVE_MASS]: t('Notification.CommonTitleMassArchivedKey', {
      count,
      totalCount,
    }),
    [FLAT_ACTION_RESTORE_ITEM]: t('Notification.CommonTitleRestoredKey'),
    [FLAT_ACTION_RESTORE_MASS]: t('Notification.CommonTitleMassRestoredKey', {
      count,
      totalCount,
    }),
  }

  return types[action] || null
}

export function getFlatTableAsyncNotificationText({ action, t }) {
  const types = {
    [FLAT_ACTION_ARCHIVE_MASS]: t('Notification.FlatAsyncTextMassArchiveKey'),
    [FLAT_ACTION_RESTORE_MASS]: t('Notification.FlatAsyncTextMassRestoreKey'),
  }

  return types[action] || null
}

export function getFlatTableItemActions({ permissions }) {
  const items = [
    {
      label: 'Flat.EmailActionOptionKey',
      permission: permissions.can_create_mass_mailing,
      value: FLAT_ACTION_EMAIL_ITEM,
    },
    null,
    {
      label: 'Flat.ArchiveActionOptionKey',
      permission: permissions.can_archive,
      value: FLAT_ACTION_ARCHIVE_ITEM,
    },
    {
      label: 'Flat.RestoreActionOptionKey',
      permission: permissions.can_restore,
      value: FLAT_ACTION_RESTORE_ITEM,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getFlatTableMassActions({ permissions, sub, t }) {
  const isArchiveSub = isSubArchive(sub)

  const canMassEmail = !isArchiveSub && permissions.can_create_mass_mailing

  const items = [
    {
      label: t('Flat.MassActionEmailAllUsersOptionKey'),
      permission: canMassEmail,
      value: FLAT_ACTION_MASS_EMAIL_ALL_USERS,
    },
    {
      label: t('Flat.MassActionEmailLandlordsOptionKey'),
      permission: canMassEmail,
      value: FLAT_ACTION_MASS_EMAIL_LANDLORDS,
    },
    {
      label: t('Flat.MassActionEmailTenantsOptionKey'),
      permission: canMassEmail,
      value: FLAT_ACTION_MASS_EMAIL_TENANTS,
    },
    null,
    {
      label: t('Flat.ArchiveMassActionOptionKey'),
      permission: permissions.can_archive && !isArchiveSub,
      value: FLAT_ACTION_ARCHIVE_MASS,
    },
    {
      label: t('Flat.RestoreMassActionOptionKey'),
      permission: permissions.can_restore && isArchiveSub,
      value: FLAT_ACTION_RESTORE_MASS,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}
